export default "__VITE_ASSET__aFl2Y3ns__"